(function () {
  "use strict";

  // Prevent double-init if script loads twice (theme sections, AJAX cart, etc.)
  if (window.__sizeGuidePopupInitialized) return;
  window.__sizeGuidePopupInitialized = true;

  const CM_TO_IN = 0.393701;

  function toIn(cm) {
    if (isNaN(cm)) return "";
    return Math.round(cm * CM_TO_IN);
  }

  function convertRange(value) {
    if (!value) return "";
    if (value.indexOf("–") > -1 || value.indexOf("-") > -1) {
      const parts = value.split(/[–-]/).map((v) => parseFloat(v));
      if (parts.some((v) => isNaN(v))) return value; // fallback: don't break on bad data
      return `${toIn(parts[0])}–${toIn(parts[1])}`;
    }
    const num = parseFloat(value);
    return isNaN(num) ? value : toIn(num);
  }

  function updateIndicator(group, btn) {
    if (!group || !btn) return;
    const indicator = group.querySelector(".size_guide_indicator");
    if (!indicator) return;

    const btnRect = btn.getBoundingClientRect();
    const groupRect = group.getBoundingClientRect();
    indicator.style.width = btn.offsetWidth + "px";
    indicator.style.transform = `translateX(${btnRect.left - groupRect.left}px)`;
  }

  function initToggleGroups(scope) {
    const groups = scope.querySelectorAll(".size_guide_group");
    if (!groups.length) return; // nothing to do on this page

    groups.forEach((group) => {
      const buttons = group.querySelectorAll(".size_guide_btn");
      if (!buttons.length) return;

      const activeBtn = group.querySelector(".size_guide_active") || buttons[0];
      activeBtn.classList.add("size_guide_active");
      updateIndicator(group, activeBtn);
    });
  }

  function applyUnit(modal, unit) {
    if (!modal) return;
    const rows = modal.querySelectorAll(".size_guide_table tbody tr");
    if (!rows.length) return;

    rows.forEach((row) => {
      row.querySelectorAll(".cm_in").forEach((cell) => {
        if (!cell.dataset.cm) {
          cell.dataset.cm = cell.textContent.trim();
        }
        cell.textContent = unit === "cm" ? cell.dataset.cm : convertRange(cell.dataset.cm);
      });
    });
  }

  function reInitIndicators(scope) {
    if (!scope) return;
    scope.querySelectorAll(".size_guide_group").forEach((group) => {
      const activeBtn = group.querySelector(".size_guide_active");
      if (activeBtn) updateIndicator(group, activeBtn);
    });
  }

  function openModal(modal) {
    if (!modal) return;
    modal.setAttribute("aria_hidden", "false");
    modal.classList.add("is-open");
    document.body.classList.add("sg-modal-open");

    // Re-sync pill position once modal is visible (offsetWidth needs layout)
    requestAnimationFrame(() => reInitIndicators(modal));
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute("aria_hidden", "true");
    modal.classList.remove("is-open");
    document.body.classList.remove("sg-modal-open");
  }

  // ---- Single delegated click listener for the whole document ----
  document.addEventListener("click", function (e) {
    // Open trigger
    const openTrigger = e.target.closest("[data-size-guide], .sg_open");
    if (openTrigger) {
      const popup = document.querySelector("#size_guide_popup");
      openModal(popup);
      return;
    }

    // Close trigger (close button or overlay)
    const closeTrigger = e.target.closest(".sg_close, .sg_overlay");
    if (closeTrigger) {
      const modal = closeTrigger.closest(".sg_modal");
      closeModal(modal);
      return;
    }

    // cm/in toggle buttons
    const unitBtn = e.target.closest(".size_guide_group .size_guide_btn");
    if (unitBtn) {
      const group = unitBtn.closest(".size_guide_group");
      if (!group) return;

      group.querySelectorAll(".size_guide_btn").forEach((b) => b.classList.remove("size_guide_active"));
      unitBtn.classList.add("size_guide_active");
      updateIndicator(group, unitBtn);

      const unit = unitBtn.textContent.trim().toLowerCase();
      const modal = unitBtn.closest("#size_guide_popup") || document;
      applyUnit(modal, unit);
      return;
    }
  });

  // ESC key closes modal
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const openModalEl = document.querySelector(".sg_modal.is-open");
    if (openModalEl) closeModal(openModalEl);
  });

  // Debounced resize re-sync
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      reInitIndicators(document);
    }, 150);
  });

  // Init on load — safe no-op if popup isn't on the page
  document.addEventListener("DOMContentLoaded", function () {
    initToggleGroups(document);
  });
})();